/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
import axios from 'axios'
import { logger } from '@plugins/logger'
import { getApiUrl } from '@utils/api-helpers'
import { debounce } from '@utils/timing'

// SBE uses local session storage to managage applicaton across different pages, page reloads and page redirects
// These items are set after ReadReservation API is called

// ReadReservation API response
const storedReservationsData = sessionStorage.getItem('storedReservationsData')
// Payload for ReadReservation
const storedReservationLookUpData = sessionStorage.getItem('storedReservationLookUpData')
// Reservation/s selected during modify flow
const storedSelectedReservations = sessionStorage.getItem('storedSelectedReservations')
// Flag to show reservation/s modify success message after modify flow
const storedReservationModifiedSuccess = sessionStorage.getItem('storedReservationModifiedSuccess') === 'true'
// SBE CMS dictionary and settings properties
const storedModifyBookingPropData = sessionStorage.getItem('storedModifyBookingPropData')
// Boolean flag to determine if in regular booking mode or SBE edit mode
const storedBookingEditMode = sessionStorage.getItem('storedBookingEditMode') === 'true'

export default {
  namespaced: true,
  state: {
    currentReservationData: storedReservationsData ? JSON.parse(storedReservationsData) : null,
    currentReservationLookUpData: storedReservationLookUpData ? JSON.parse(storedReservationLookUpData) : null,
    selectedReservations: storedSelectedReservations ? JSON.parse(storedSelectedReservations) : [],
    readReservationLoading: false,
    cancelReservationLoading: false,
    selectedReservationsToCancel: null,
    readReservationError: null,
    cancelReservationErrorMessage: null,
    cancelReservationError: null,
    modifyBookingPropData: storedModifyBookingPropData ? JSON.parse(storedModifyBookingPropData) : null,
    checkInactivityIntervalId: null,
    showSessionEndPopUp: false,
    allReservationsAreCancelled: storedReservationsData ? JSON.parse(storedReservationsData).reservations.every((item) => item.status === 'Cancelled') : false,
    showReservationModifiedSuccess: storedReservationModifiedSuccess,
    isBookingEditMode: storedBookingEditMode || false,
    waitingTimeoutId: null,
  },
  mutations: {
    READ_RESERVATION_LOADING(state, loading) {
      state.readReservationLoading = loading
      if (loading) {
        state.readReservationError = null
      }
    },
    READ_RESERVATION(state, payload) {
      sessionStorage.setItem('storedReservationsData', JSON.stringify(payload))
      this._vm.$set(state, 'currentReservationData', payload)
      state.isMultiRoomReservation = payload.reservations.length > 1
      state.readReservationError = null
      state.allReservationsAreCancelled = payload.reservations.every((item) => item.status === 'Cancelled')
    },
    SAVE_LOOKUP_DATA(state, payload) {
      sessionStorage.setItem('storedReservationLookUpData', JSON.stringify(payload))
      state.currentReservationLookUpData = payload
    },
    READ_RESERVATION_ERROR(state, payload) {
      logger.debug('READ_RESERVATION_ERROR', payload)
      state.readReservationError = payload.noResultMessage !== '' ? payload.noResultMessage : 'Something went wrong'
    },
    CANCEL_RESERVATION_LOADING(state, loading) {
      state.cancelReservationLoading = loading
    },
    CANCEL_RESERVATION(state, payload) {
      state.selectedReservationsToCancel = payload
      setTimeout(() => {
        state.selectedReservationsToCancel = null
      }, state.modifyBookingPropData.ModifyReservationAlertTimer)
    },
    CANCEL_RESERVATION_ERROR(state, payload) {
      state.cancelReservationError = !!payload.errors.length
      state.cancelReservationErrorMessage = payload.errors[0]
    },
    RESET_CANCEL_ERROR_MESSAGE(state) {
      state.cancelReservationErrorMessage = null
      state.cancelReservationError = null
    },
    MODIFY_RESERVATION(state, updatedReservation) {
    },
    SET_INTERVAL(state, intervalId) {
      state.checkInactivityIntervalId = intervalId
    },
    SHOW_INACTIVE_POPUP(state) {
      state.showSessionEndPopUp = true
    },
    RESET_ALL_SESSION_DATA(state) {
      sessionStorage.removeItem('storedReservationLookUpData')
      sessionStorage.removeItem('storedReservationsData')
      sessionStorage.removeItem('storedReservationTimeToOpen')
      sessionStorage.removeItem('storedSelectedReservations')
      sessionStorage.removeItem('storedModifyBookingPropData')
      sessionStorage.removeItem('storedReservationTimeToOpen')
      sessionStorage.removeItem('storedBookingEditMode')
      sessionStorage.removeItem('storedReservationMyStaysEntry')
    },
    REGISTER_MODIFY_PROP_DATA(state, payload) {
      state.modifyBookingPropData = payload
      sessionStorage.setItem('storedModifyBookingPropData', JSON.stringify(payload))
    },
    UPDATE_BOOKING_EDIT_MODE(state, val) {
      state.isBookingEditMode = val
      sessionStorage.setItem('storedBookingEditMode', val)
    },
    UPDATE_SELECTED_RESERVATIONS(state, val) {
      state.selectedReservations = val.sort((a, b) => Number(a.roomNumberOrder) - Number(b.roomNumberOrder))
      sessionStorage.setItem('storedSelectedReservations', JSON.stringify(state.selectedReservations))
    },
    REMOVE_SHOW_RESERVATION_MODIFY_SUCCESS(state, val) {
      state.showReservationModifiedSuccess = val
      state.selectedReservations = []
      sessionStorage.removeItem('storedSelectedReservations')
    },
    SET_WAITING_TIMEOUT(state, timeoutId) {
      state.waitingTimeoutId = timeoutId
    },
    HIDE_INACTIVE_POPUP(state) {
      state.showSessionEndPopUp = false
    }
  },
  actions: {
    toggleBookingEditMode({ commit }, val) {
      commit('UPDATE_BOOKING_EDIT_MODE', val)
    },
    async readReservation({ commit, rootState }, { lookUpDataObject }) {
      let data = null
      try {
        commit('READ_RESERVATION_LOADING', true)
        const res = await axios.post(getApiUrl('/api/v1/booking/ReadReservation'),
          {
            ...lookUpDataObject,
            primaryLanguage: rootState.global.lang
          })
        data = res.data
        if (data.reservations) {
          commit('READ_RESERVATION', data)
          commit('SAVE_LOOKUP_DATA', lookUpDataObject)
          logger.debug('ReadReservation Lookup Payload', lookUpDataObject)
          logger.debug('ReadReservation Response', data)
        } else {
          logger.debug('ReadReservation Response', data)
          commit('SAVE_LOOKUP_DATA', lookUpDataObject)
          commit('READ_RESERVATION_ERROR', data)
        }
      } catch (err) {
        logger.debug('ReadReservation Response Error', err)
        commit('READ_RESERVATION_ERROR', 'Something went wrong')
      } finally {
        commit('READ_RESERVATION_LOADING', false)
      }
      return data
    },
    async cancelReservation({ commit }, roomSelectionsData) {
      let data = null
      let cancelPayload = null
      logger.debug('roomSelectionsData', roomSelectionsData)

      // Multi-room data with all rooms selected
      // Send Itinerary and Hotel code
      if (roomSelectionsData.AllMultiRoomsSelected) {
        cancelPayload = {
          ConfirmationNumbers: [],
          ItineraryNumber: roomSelectionsData.ConfirmationSelections[0].Itinerary,
          HotelCode: roomSelectionsData.ConfirmationSelections[0].HotelCode,
        }
      } else {
        // Multi-room when all rooms not selected. Send all confirmation numbers
        const confirmationNumbers = roomSelectionsData.ConfirmationSelections.map((item) => item.ConfirmationNumber)
        cancelPayload = {
          ConfirmationNumbers: confirmationNumbers,
          ItineraryNumber: '',
          HotelCode: '',
        }
      }

      logger.debug('cancelPayload', cancelPayload)

      try {
        commit('CANCEL_RESERVATION_LOADING', true)
        const response = await axios.post(getApiUrl('/api/v1/booking/cancel'), cancelPayload)
        data = response.data
        commit('CANCEL_RESERVATION', data)
        if (data.errors.length) {
          logger.debug('Cancel error', data.errors)
          commit('CANCEL_RESERVATION_ERROR', data)
        }
      } catch (err) {
        logger.debug('Cancel error', err)
      } finally {
        commit('CANCEL_RESERVATION_LOADING', false)
      }

      return data
    },
    async editReservation({ commit }, ConfirmationNumber) {
      let data = null
      try {
        await axios.post(getApiUrl('/api/v1/booking/edit'), {
          ConfirmationNumber,
        }).then((res) => {
          data = res.data
          if (data.status) {
            commit('EDIT_RESERVATION', data)
          }
        })
      } catch (err) {
        logger.debug('editReservation error', err)
      }
      return data
    },
    manageReservationSession({ dispatch }) {
      dispatch('initializeSessionManagement')
    },
    initializeSessionManagement({ dispatch }) {
      // Initialize session timeout tracking
      dispatch('setWait')
      // Set the session expiration time
      dispatch('setModifySessionTimeToEnd')
      // Start monitoring for inactivity
      dispatch('startInactivityCheck')
    },
    setModifySessionTimeToEnd({ state }) {
      // Calculate session timeout (default 10 minutes if not specified)
      const timeoutMinutes = state.modifyBookingPropData?.ModifyReservationIdleTimer
        ? Number(state.modifyBookingPropData.ModifyReservationIdleTimer)
        : 10

      const expirationTime = Date.now() + (timeoutMinutes * 60000)
      sessionStorage.setItem('storedReservationTimeToOpen', expirationTime)
    },
    resetWait({ dispatch }) {
      dispatch('setModifySessionTimeToEnd')
    },
    setWait({ dispatch }) {
      // Create debounced function to handle user activity
      const handleUserActivity = debounce(() => {
        dispatch('resetWait')
        // Reload if no reservation data exists
        if (!sessionStorage.getItem('storedReservationsData')) {
          window.location.reload()
        }
      }, 1000)

      // Setup activity tracking
      const activityEvents = ['mousemove', 'touchstart', 'touchend', 'touchcancel', 'touchmove', 'wheel', 'click', 'keypress']
      const eventListeners = new Map()

      // Attach listeners for all activity events
      activityEvents.forEach((event) => {
        const listener = () => handleUserActivity()
        document.addEventListener(event, listener, { passive: true })
        eventListeners.set(event, listener)
      })

      // Cleanup function to remove event listeners
      const cleanup = () => {
        eventListeners.forEach((listener, event) => {
          document.removeEventListener(event, listener)
        })
      }

      // Handle existing cleanup if present
      if (window._sessionCleanup) {
        window._sessionCleanup()
      }
      window._sessionCleanup = cleanup
    },
    startInactivityCheck({ commit, state, rootState }) {
      // Clear any existing interval
      if (state.checkInactivityIntervalId) {
        clearInterval(state.checkInactivityIntervalId)
      }

      // Start monitoring for inactivity
      const intervalId = setInterval(() => {
        const timeToReopen = parseInt(sessionStorage.getItem('storedReservationTimeToOpen'), 10)
        const userProfile = rootState?.auth?.user

        // Check if session has expired
        if (Date.now() >= timeToReopen) {
          clearInterval(intervalId)
          commit('SHOW_INACTIVE_POPUP')

          // Set timeout for auto-logout
          const autoLogoutDelay = 30000 // 30 seconds
          const waitingTimeout = setTimeout(() => {
            if (state.showSessionEndPopUp) {
              if (!userProfile) {
                commit('RESET_ALL_SESSION_DATA')
                window.location.reload()
              }
              commit('HIDE_INACTIVE_POPUP')
            }
          }, autoLogoutDelay)
          commit('SET_WAITING_TIMEOUT', waitingTimeout)
        }
      }, 1000) // Check every second

      commit('SET_INTERVAL', intervalId)
    },
    registerModifyBookingPropData({ commit }, data) {
      commit('REGISTER_MODIFY_PROP_DATA', data)
    },
    resetCancelErrorMessage({ commit }) {
      commit('RESET_CANCEL_ERROR_MESSAGE')
    },
    updatedSelectedReservations({ commit }, selectedReservations) {
      commit('UPDATE_SELECTED_RESERVATIONS', selectedReservations)
    },
    setReservationModifySuccessInSession({ commit }) {
      sessionStorage.setItem('storedReservationModifiedSuccess', true)
    },
    removeReservationModifySuccess({ commit, state }) {
      setTimeout(() => {
        commit('REMOVE_SHOW_RESERVATION_MODIFY_SUCCESS', false)
        sessionStorage.removeItem('storedReservationModifiedSuccess')
      }, state.modifyBookingPropData.ModifyReservationAlertTimer)
    },
    restartModifyBookingEngine({ commit }) {
      commit('RESET_ALL_SESSION_DATA')
    },
    continueSession({ commit, state, dispatch }) {
      if (state.waitingTimeoutId) {
        clearTimeout(state.waitingTimeoutId)
      }
      commit('HIDE_INACTIVE_POPUP')
      dispatch('resetWait')
      dispatch('startInactivityCheck')
    },
    endSession({ commit, rootState }) {
      const userProfile = rootState?.auth?.user
      if (!userProfile) {
        commit('RESET_ALL_SESSION_DATA')
      }
      commit('HIDE_INACTIVE_POPUP')
    }
  },
  getters: {
    currentReservationLookUpData: (state) => state.currentReservationLookUpData,
    isMultiRoomReservation: (state) => state.currentReservationData?.reservations?.length > 1,
    hasReservationData: (state) => !!state.currentReservationData && Object.keys(state.currentReservationData).length > 0,
    hasSelectedReservation: (state) => !!state.selectedReservations.length,
    reservationGuestProfile: (state) => state.currentReservationData?.primaryProfileModel,
    storedModifyBookingPropData: (state) => state.modifyBookingPropData,
    getBookingTrackingModifyReservation: (state, getters, rootState, rootGetters) => (query = rootState.booking.query, eventData) => {
      const userProfile = rootState.auth.user
      let userParams = {}
      if (userProfile) {
        userParams = {
          user: {
            accountType: rootGetters['auth/fanLevel'],
            accountNumber: rootGetters['auth/userId'] ? rootGetters['auth/userId'].toLowerCase() : '',
            loginState: 'logged in',
            ireckonuID: userProfile?.personId?.toString() || null
          }
        }
      }
      return {
        ...eventData,
        page: {
          name: query.name || undefined,
          hotelCode: query.hotelCode || 'global',
          siteSection: `modify booking engine - ${query.siteSection}`,
          template: 'sbe'
        },
        ...userParams
      }
    }
  }
}
